<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
    <v-list>
      <v-list-tile 
          v-for="(link, i) in links_EN" :key="i"
          :to="link.to"
          :href="link.href"
          @click="$vuetify.goTo(link.href, options)" >
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import * as easings from 'vuetify/es5/util/easing-patterns'
import { MyFunctions } from '@/data/functions.js'
export default {
  name: 'Drawer',
  props:['drawer'],
      data () {
          return {
            language: '',
            easings: Object.keys(easings),
              links_RU: [
                {text: 'Оксана', href: '#oksana'},
                {text: 'Портфолио', href: '#portfolio'},  
                {text: 'Галерея', href: '#gallery'}, 
                {text: 'Ведущая-конферансье', href: '#ceremony'},
                {text: 'Контакты', href: '#contacts'},
                {text: 'Комментарии и отзывы', href: '#comments'}                                                 
              ],
              links_EN: [
                {text: 'Oksana', href: '#oksana'},
                {text: 'Portfolio', href: '#portfolio'},  
                {text: 'Gallery', href: '#gallery'}, 
                {text: 'Master of Ceremony', href: '#ceremony'},
                {text: 'Contacts', href: '#contacts'},   
                {text: 'Comments & testinoinals', href: '#comments'}                                               
              ],
              links_UA: [
                {text: 'Оксана', href: '#oksana'},
                {text: 'Портфоліо', href: '#portfolio'},  
                {text: 'Галерея', href: '#gallery'}, 
                {text: 'Ведуча-конферансьє', href: '#ceremony'},      
                {text: 'Контакты', href: '#contacts'},
                {text: 'Контакти', href: '#comments'}                                                          
              ],  
          }
        },  
    mounted(){
      this.language = MyFunctions.getLanguage()
  },
  computed: {
    target () {
      const value = this[this.type]
        if (!isNaN(value)) return Number(value)
        else return value
      },
    options () {
      return {
        duration: 900,
        offset: 0,
        easing: 'easeInOutCubic'        
      }
    }
  }
}
</script>
